document.addEventListener("DOMContentLoaded", function() {
    let hamburger = document.querySelectorAll('.JS-hamburger'),
        menu = document.querySelector('.responsive-menu-holder'),
        body = document.body,
        clone = document.querySelector('.efect-clone');

    menu.querySelectorAll('.uroven-2').forEach(function (el) {
        let anchor = document.createElement('span');
        el.parentNode.insertBefore(anchor, el.parentNode.firstChild);
        el.parentNode.firstChild.classList.add("PR-anchor");
    });

    let anchor = document.querySelectorAll('.PR-anchor');

    hamburger.forEach(el => {
        el.addEventListener('click', function () {
            hamburger.forEach(eachHamburger => {
                eachHamburger.classList.toggle('is-active');
            });
            menu.classList.toggle('is-active');
            body.classList.toggle('no-scroll');
            anchor.forEach(function (el) {
                el.classList.remove('is-active');
            });
        });
    });

    clone.addEventListener('click', function () {
        hamburger.forEach(eachHamburger => {
            eachHamburger.classList.toggle('is-active');
        });
        menu.classList.toggle('is-active')
        body.classList.toggle('no-scroll');
        anchor.forEach(function (el) {
            el.classList.remove('is-active');
        });
    });

    menu.querySelectorAll('.PR-anchor').forEach(function (el) {
        el.addEventListener('click', function (e) {
            let parent = el.parentNode;
            e.preventDefault();
            el.classList.toggle('is-active');
            parent.classList.toggle('is-active');
            el.nextElementSibling.nextElementSibling.classList.toggle('is-active');
        });
    });

    // Reset pri resizu
    //=================
    window.addEventListener('resize', function () {
        menu.querySelectorAll('.uroven-2').forEach(function (el) {
            el.style.display = '';
        });
        menu.querySelectorAll('li').forEach(function (el) {
            el.classList.remove('is-active');
        });
        anchor.forEach(function (el) {
            el.classList.remove('is-active');
        });
    });
});